import { Component, ElementRef, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild, ViewEncapsulation, HostListener } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'
import { SignalrService } from 'app/signalr.service'

@Component({
  selector: 'chat-input',
  templateUrl: './chat-input.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./chat-input.component.css'],
})
export class ChatInputComponent implements OnInit, OnDestroy {
  @Input() public buttonText = '↩︎'
  @Input() public focus = new EventEmitter()
  @Output() public send = new EventEmitter()
  @Output() public composerChange = new EventEmitter()
  @Output() public dismiss = new EventEmitter()
  @ViewChild('message', { static: true }) message: ElementRef
  @ViewChild('emoji') emoji: ElementRef;
  @ViewChild('emojiAnexo') emojiAnexo: ElementRef;
  @ViewChild('file') file: ElementRef;
  @ViewChild('messageAnexo') messageAnexo: ElementRef;

  chatWidget = document.querySelector("chat-widget");
  // Verificar o uso - se nao tiver, deletar "clicouDentro"
  clicouDentro: boolean = true;

  public active : boolean = false;
  public isEmojiPickerVisible: boolean = false;
  
  isAnexoEmojiPickerVisible: boolean = false;
  anexoSelecionado: boolean = false;
  indiceAnexo: number = 0;
  listaAnexosSelecionados: any[] = [];

  public gravandoAudio: boolean= false;
  public hasGuid: boolean = true;

  public readonly limiteCaracteres: number = 1000;
  public caracteresRestantes: number = this.limiteCaracteres;

  public get mostrarContador(): boolean {
    return this.caracteresRestantes <= 100;
  }

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  traducaoEmoji: any = {
    search: 'Pesquisar',
    emojiLlist: 'Lista de emojis',
    notfound: 'Emoji não encontrado',
    clear: 'Limpar',
    categories: {
      search: 'Resultados da Pesquisa',
      recent: 'Recém Utilizados',
      people: 'Faces e Pessoas',
      nature: 'Animais e Natureza',
      foods: 'Comidas e Bebidas',
      activity: 'Atividades',
      places: 'Viagem e Lugares',
      objects: 'Objetos',
      symbols: 'Símbolos',
      flags: 'Bandeiras',
      custom: 'Personalizados'
    }
  }

    constructor(private _signalR: SignalrService

    ){}
  
  ngOnInit() {
    this.focus
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => this.focusMessage())

    this.chatWidget?.shadowRoot?.addEventListener(
      'mousedown',
      this.onChatWidgetMouseDown
    )

    this._signalR.conversaIniciada$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((iniciada: boolean) => {
        this.hasGuid = iniciada
      })
  }

  ngOnDestroy() {
    this.chatWidget?.shadowRoot?.removeEventListener(
      'mousedown',
      this.onChatWidgetMouseDown
    )

    this._unsubscribeAll.next(null)
    this._unsubscribeAll.complete()
  }

  private onChatWidgetMouseDown = (event: any) => {
    if (this.emoji != undefined) {
      if (
        this.emoji['scrollRef']
          .nativeElement
          .parentElement
          .contains(event.target)
      ) {
        this.isEmojiPickerVisible = true
        event.stopPropagation()
        return
      }
    }

    if (this.emojiAnexo != undefined) {
      if (
        this.emojiAnexo['scrollRef']
          .nativeElement
          .parentElement
          .contains(event.target)
      ) {
        this.isAnexoEmojiPickerVisible = true
        event.stopPropagation()
      }
    }
  }

  public focusMessage() {
    this.message.nativeElement.focus()
  }

  public getMessage() {
    return this.message.nativeElement.value
  }

  public clearMessage() {
    this.message.nativeElement.value = ''
    this.active = false
    this.caracteresRestantes = this.limiteCaracteres
    this.ajustarAltura()
  }

  public verifyText(e){
    const texto: string = e.target.value ?? ''
    this.active = texto.trim() !== ''
    this.caracteresRestantes = this.limiteCaracteres - texto.length
    this.ajustarAltura()
  }

  private ajustarAltura() {
    const el = this.message?.nativeElement
    if (el == null) {
      return
    }
    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, 132)}px`
  }

  public addEmoji(event, anexo?) {
    this.concatEmoji(event.emoji.native, anexo)
    this.isEmojiPickerVisible = false;
    this.isAnexoEmojiPickerVisible = false;
  }

  public concatEmoji(emoji, anexo?) {
    if (anexo) {
      const item = this.listaAnexosSelecionados[this.indiceAnexo]

      if (item == null) {
        return
      }

      item.legenda = `${item.legenda || ''}${emoji}`
      this.messageAnexo.nativeElement.value = item.legenda

      return this.messageAnexo.nativeElement.focus()
    }

    const valorAtual = this.message.nativeElement.value

    if (valorAtual.length + emoji.length > this.limiteCaracteres) {
      return
    }

    this.message.nativeElement.value = `${valorAtual}${emoji}`

    const texto = this.message.nativeElement.value

    this.active = texto.trim() !== ''
    this.caracteresRestantes = this.limiteCaracteres - texto.length
    this.ajustarAltura()

    return this.focusMessage()
  }

  selecionarAnexo(e) {
    if (e.target.value != undefined && e.target.value != "") {
      const arquivo = e.target.files[0]

      arquivo.legenda = ''

      this.anexoSelecionado = true
      this.listaAnexosSelecionados.push(arquivo)

      this.indiceAnexo = this.listaAnexosSelecionados.length - 1

      e.target.value = ''

      this.composerChange.emit()
    }
  }

  atualizarLegendaAnexo(e) {
    const anexo = this.listaAnexosSelecionados[this.indiceAnexo]

    if (anexo == null) {
      return
    }

    anexo.legenda = e.target.value
  }

  enviarAnexo(listaAnexos: any) {
    if (!listaAnexos?.length) {
      return
    }

    listaAnexos.forEach(item => {
      this.onSubmit(item)
    })

    this.listaAnexosSelecionados = []
    this.anexoSelecionado = false
    this.file.nativeElement.value = ''
    this.messageAnexo.nativeElement.value = ''
    this.indiceAnexo = 0
  }

  fecharAnexo(){
    this.anexoSelecionado = false;
    this.listaAnexosSelecionados = [];
    this.file.nativeElement.value = "";
    this.messageAnexo.nativeElement.value = "";
    this.indiceAnexo = 0;
  }

  selecionarAnexoIndice(indice: number) {
    if (
      indice < 0 ||
      indice >= this.listaAnexosSelecionados.length
    ) {
      return
    }

    this.indiceAnexo = indice
  }

  passaAnexo() {
    if (this.indiceAnexo < this.listaAnexosSelecionados.length - 1) {
      ++this.indiceAnexo
    }
  }

  voltaAnexo() {
    if (this.indiceAnexo > 0) {
      --this.indiceAnexo
    }
  }

  public verificaEnter(e, anexo?) {

    // Shift + Enter na legenda: permite quebra de linha
    if (anexo && e.key === 'Enter' && e.shiftKey) {
      return
    }

    // Enter na legenda: envia os anexos
    if (anexo && e.key === 'Enter') {
      this.enviarAnexo(this.listaAnexosSelecionados)
      return e.preventDefault()
    }

    // Shift + Enter na mensagem: permite quebra de linha
    if (e.key === 'Enter' && e.shiftKey) {
      return
    }

    // Enter na mensagem: envia
    if (e.key === 'Enter') {
      this.onSubmit()
      return e.preventDefault()
    }
  }

  getNomeAnexo(nome: string): string {
    return nome.split('/')[nome.split('/').length - 1];
  }

  getExtensaoAnexo(nome: string): string {
    const nomeArquivo = this.getNomeAnexo(nome ?? '');
    const indicePonto = nomeArquivo.lastIndexOf('.');

    if (indicePonto === -1 || indicePonto === nomeArquivo.length - 1) {
      return '';
    }

    return nomeArquivo.substring(indicePonto + 1).toLowerCase();
  }

  formataBytes(a,b=2){if(!+a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return`${parseFloat((a/Math.pow(1024,d)).toFixed(c))} ${["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}`}

  onSubmit(anexo?) {
    var message = this.getMessage();

    if(anexo!= undefined){
      message = anexo;
    }

    if (/^\s+$/.test(message) && anexo == undefined || message == "" && anexo == undefined || message == null) {
      return 
    }

    if (anexo == undefined && typeof message === 'string' && message.length > this.limiteCaracteres) {
      message = message.substring(0, this.limiteCaracteres)
    }

    this.send.emit({ message })
    this._signalR.marcarConversaIniciada()
    this.clearMessage()
    this.focusMessage()
  }

  @HostListener('document:mousedown', ['$event'])
  handleClickEvent(event) {
    this.isEmojiPickerVisible = false
    this.isAnexoEmojiPickerVisible = false
    event.stopPropagation();
  }

public enviarAudio(arquivo: File): void {
    if (!arquivo) return;

    const listaAudio = [
        arquivo        
    ];

    this.enviarAnexo(listaAudio);
}

  onInicioGravacao(): void {
    this.gravandoAudio = true;
  }

  onFinalizarGravacao(): void {
    this.gravandoAudio = false;
  }

}
